import { useQuery } from "@tanstack/react-query";
import React, { useContext } from "react";
import { Link, Outlet } from "react-router-dom";
import { AuthContext } from "../contexts/AuthProvider/AuthProvider";
import useAdmin from "../hooks/useAdmin";

import useSeller from "../hooks/useSeller";

import Navbar from "../Pages/Shared/Navbar/Navbar";

const DashboardLayout = () => {
  const { user } = useContext(AuthContext);
  const [isAdmin] = useAdmin(user?.email);
  const [isSeller] = useSeller(user?.email);

  const { data: users = [], refetch } = useQuery({
    queryKey: ["users"],
    queryFn: async () => {
      const res = await fetch("https://bookworm-server.vercel.app/users");
      const data = await res.json();
      return data;
    },
  });

  return (
    <div>
      <Navbar></Navbar>
      <div className="drawer drawer-mobile">
        <input
          id="dashboard-drawer"
          type="checkbox"
          className="drawer-toggle"
        />
        <div className="drawer-content">
          <Outlet></Outlet>
        </div>
        <div className="drawer-side">
          <label htmlFor="dashboard-drawer" className="drawer-overlay"></label>
          <ul className="menu p-4 w-80 bg-base-100 text-base-content">
            {isSeller && (
              <li>
                <Link to="/dashboard/addproduct">Add A Product</Link>
              </li>
            )}
            {isAdmin && (
              <li>
                <Link to="/dashboard/allusers">All Buyers</Link>
                <Link to="/dashboard/allseller">All Seller</Link>
                <Link to="/dashboard/report">Reported Items</Link>
              </li>
            )}
            {!isSeller && !isAdmin ? (
              <li>
                <Link to="/dashboard">My Orders</Link>
              </li>
            ) : (
              <div></div>
            )}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default DashboardLayout;
